import React, { useEffect, useState } from "react";
import "../../../modifier/listing/ModifierListing.scss";
import "../associated-providers/Providers.scss";
import emptyIcon from "assets/images/emptyIcon.svg";
import LoaderBlock from "shared/loader/LoaderBlock";
import toastify from "shared/toastr";
import plusIcon from "assets/images/add-icon-white.svg";
import {
  getKitchenIntegrationData,
  getIntegrationsDropdownList,
} from "services/api/kitchen";
import IntegrationsEdit from "./IntegrationsEdit";
import IntegrationsRow from "./IntegrationsRow";

const IntegrationsList = (props) => {
  const kitchen = props.kitchen;
  const kitchenId = kitchen?.id;

  const [allProviders, setallProviders] = useState(null);
  const [dropdownProvidersList, setDropdownProvidersList] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [isShowAddProvider, setIsShowAddProvider] = useState(false);

  useEffect(() => {
    if (kitchenId) {
      getListing();
    }
  }, [kitchenId]);

  const openModal = () => {
    setIsShowAddProvider(true);
  };
  const closeModal = () => {
    setIsShowAddProvider(false);
  };

  const getListing = async () => {
    setisLoading(true);

    await getIntegrationsDropdownList()
      .then((res) => {
        setDropdownProvidersList(res?.data);
      })
      .catch((e) => {
        toastify("error", e.message);
      });

    await getKitchenIntegrationData(kitchenId)
      .then((res) => {
        let data = res.data;
        setallProviders(data);
        setisLoading(false);
      })
      .catch((e) => {
        setallProviders(null);
        setisLoading(false);
      });
  };

  return (
    <>
      <div className="managermodifier__wrapper basic__info__content">
        <div className="container">
          <div className="managermodifier__header modifiers_heading_padding">
            <div className="row">
              <div className="col-12 col-lg-6 mb-0 mb-md-3 mb-lg-0">
                <h2>POS</h2>
              </div>
              <div className="col-12 col-lg-6">
                <div
                  className="form flex-column flex-md-row"
                  id="manage__modifier__search__form"
                >
                  <div className="search__modifiers"></div>
                  <button onClick={openModal} className="red-btn btn">
                    <span className="icons-left icons">
                      <img src={plusIcon} alt="add icon" />
                    </span>
                    Add New Integration
                  </button>
                </div>
              </div>
            </div>
          </div>
          {allProviders == null && !isLoading ? (
            <div className="restaurantdetails__noListing">
              <div className="managermodifier__noListing__innerwrapper">
                <div className="content">
                  <div className="img-box">
                    <img
                      className="img-fluid"
                      src={emptyIcon}
                      alt="no list icon"
                      width="185"
                    />
                  </div>
                  <div className="content-desc">
                    <h3>{"No integrations are added"}</h3>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="managermodifier__listinPage">
              <div className="managermodifier__listinPage__wrapper">
                <table className="table modifierListing__table">
                  <thead>
                    <tr role="row" className="mat-header-row">
                      <th scope="col" className="mat-header-cell">
                        Name
                      </th>
                      <th scope="col" className="mat-header-cell">
                        Type
                      </th>
                      <th scope="col" className="mat-header-cell">
                        <span className="mr-4 pr-2">Status</span> Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td>
                          <LoaderBlock />
                        </td>
                      </tr>
                    ) : (
                      <IntegrationsRow
                        getListing={getListing}
                        provider={allProviders}
                        dropdownProvidersList={dropdownProvidersList}
                        kitchenId={kitchenId}
                      />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>

      {isShowAddProvider && (
        <IntegrationsEdit
          getListing={getListing}
          kitchenId={kitchenId}
          dropdownProvidersList={dropdownProvidersList}
          modalShow={isShowAddProvider}
          closeModal={closeModal}
        />
      )}
    </>
  );
};

export default IntegrationsList;